<template>
  <UModal
    v-model:open="isLoading"
    :ui="{
      overlay: ['bg-default/80'],
      content: [
        // 覆盖
        'ring-0 bg-transparent shadow-none',
      ],
    }"
  >
    <template #content>
      <div
        :class="[
          'relative',
          'flex justify-center items-center',
          '[&_img]:lg:w-48 [&_img]:w-42 [&_img]:animate-pulse',
        ]"
      >
        <!-- 半透明背景图片 -->
        <NuxtImg
          :src="configSite.LOGO"
          class="absolute opacity-30"
          draggable="false"
          alt="Loading Logo"
        />
        <!-- 前景图片带裁剪效果 -->
        <NuxtImg
          :src="configSite.LOGO"
          :style="{
            clipPath: `inset(0 ${100 - progress}% 0 0)`,
            transition: 'clip-path 0.3s ease',
          }"
          draggable="false"
          alt="Loading Logo"
        />
      </div>
    </template>
  </UModal>
</template>

<script lang="ts" setup>
  const { progress, isLoading } = useLoadingIndicator()
  const { configSite } = useConfigStatic()

  // 模拟数据调试
  //   const progress = ref(0)
  //   const isLoading = ref(true)

  //   onMounted(() => {
  //     setTimeout(() => {
  //       isLoading.value = false
  //     }, 2000)

  //     setInterval(() => {
  //       progress.value += 10
  //     }, 1000)
  //   })
</script>
